import React from 'react'
import { Redirect, Route, withRouter } from 'react-router-dom'

import { connect } from 'react-redux'

import {
  _getPermissions
} from './services'

class PrivateRoute extends React.Component {

  render() {

    const { Component } = this.props

    const isUserAuthenticated = this.getUserAuthenticated()

    if (!isUserAuthenticated) {
      return (
        <div style={{ padding: 32 }}>
          <h2>You do not have permissions to access this page. <br /><br />Please reach out to your leader for assistance.</h2>
        </div>
      )
    }

    return (
      <Route
        {...this.props}
        render={(props) => <Component {...props} />}
      />
    )
  }

  constructor(props) {

    super(props)

    this.state = {
      permissions: []
    }

    _getPermissions()
      .then(res => {
        this.setState({
          permissions: res.data.permissions
        })
      })
  }

  getUserAuthenticated = () => {

    const { user, path } = this.props
    const { permissions } = this.state

    if (user.permissions.ezSuperuser) {
      return true
    }

    const permission = permissions.filter(_permission => _permission._id == user.ezPermissionId)[0]

    if (!permission) {
      return false
    }

    const page = permission.pages.filter(_page => _page.kebabName == path.split('/')[1])[0]

    if (!page) {
      return false
    }

    return true

  }

}

export default connect(
  state => ({
    user: state.user.data
  })
)(withRouter(PrivateRoute))



// WEBPACK FOOTER //
// ./src/private-route.js